import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing }) => ({
  button: {
    marginTop: spacing(1)
  }
}))
